import React from "react";
import CheckboxTable from "../components/CheckboxTable";
import WelcomeBanner from "../components/WelcomeBanner";
import CardDesign from "../components/Card";

const TasksPage = () => {
  return (
    <>
      <WelcomeBanner />
      <div className="grid grid-cols-1 gap-0 lg:grid-cols-3 lg:gap-4">
        <div className="col-span-2">
          <CheckboxTable />
        </div>
        <div className="col-span-1 mb-4">
          <div className="flex flex-col justify-start gap-4">
            <CardDesign />
            <div className="w-full rounded-md flex-grow">
              <img
                src={process.env.PUBLIC_URL + "/upper set of widgits.jpg"}
                alt="Banner Image"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="w-full rounded-md flex-grow">
              <img
                src={process.env.PUBLIC_URL + "/vesting table.jpg"}
                alt="Banner Image"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TasksPage;
